
import Vue from 'vue';
export default Vue.extend({
  props: {
    number: {
      type: Number,
    },
    icon: {
      type: String,
    },
    headline: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: Object,
    },
  },
  data() {
    return {};
  },

  computed: {
    convertNumber(): any {
      const number = this.number;
      if (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },
  },
  mounted() {},
});
